(() => {
  if (window.Nidito) return;

  const N = {
    elegido: /[?&]variant=/.test(window.location.search),
    variante: null,
    producto: null,
  };

  N.leerProducto = () => {
    if (N.producto) return N.producto;
    const nodo = document.getElementById('nd-producto');
    if (!nodo) return null;
    try {
      N.producto = JSON.parse(nodo.textContent);
    } catch (e) {
      N.producto = null;
    }
    if (N.producto) {
      if (!N.producto.multiple) N.elegido = true;
      N.variante = N.producto.variantes.find((v) => v.id === N.producto.seleccionada) || N.producto.variantes[0] || null;
    }
    return N.producto;
  };

  N.buscarVariante = (id) => {
    const p = N.leerProducto();
    if (!p || !id) return null;
    return p.variantes.find((v) => v.id === Number(id)) || null;
  };

  N.dinero = (centimos) => {
    const formato = window.ndMoneyFormat || '{{amount_with_comma_separator}} €';
    const valor = Number(centimos || 0) / 100;
    const separar = (numero, decimales, miles, decimal) => {
      const fijo = numero.toFixed(decimales);
      const [entero, dec] = fijo.split('.');
      const conMiles = entero.replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return dec ? conMiles + decimal + dec : conMiles;
    };
    const plantilla = String(formato).replace(/<[^>]*>/g, '');
    return plantilla.replace(/\{\{\s*(\w+)\s*\}\}/, (_, clave) => {
      switch (clave) {
        case 'amount': return separar(valor, 2, ',', '.');
        case 'amount_no_decimals': return separar(valor, 0, ',', '.');
        case 'amount_with_comma_separator': return separar(valor, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return separar(valor, 0, '.', ',');
        case 'amount_with_space_separator': return separar(valor, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return separar(valor, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return separar(valor, 2, "'", '.');
        default: return separar(valor, 2, '.', ',');
      }
    });
  };

  N.track = (evento, datos, origen) => {
    if (origen && origen.closest && !origen.closest('[data-nd-tracking="true"]')) return;
    const privacidad = window.Shopify && window.Shopify.customerPrivacy;
    if (privacidad && typeof privacidad.analyticsProcessingAllowed === 'function' && !privacidad.analyticsProcessingAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: evento, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }, datos));
  };

  N.formulario = () => document.querySelector('product-info form[id^="product-form-"]') || document.querySelector('form[id^="product-form-"]');

  N.varianteActual = () => {
    const form = N.formulario();
    const input = form ? form.querySelector('input[name="id"]') : null;
    if (input && input.value) return N.buscarVariante(input.value) || { id: Number(input.value), precio: 0, disponible: true };
    return N.variante;
  };

  N.propiedades = () => {
    const props = {};
    document.querySelectorAll('[data-nd-prop]').forEach((input) => {
      const m = input.name.match(/^properties\[(.+)\]$/);
      if (m && input.value) props[m[1]] = input.value;
    });
    return props;
  };

  N.irAlFormulario = (mensaje) => {
    const selector = document.querySelector('product-info variant-selects') || N.formulario();
    if (!selector) return false;
    selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
    selector.classList.add('nd-flash');
    window.setTimeout(() => selector.classList.remove('nd-flash'), 1800);
    const ficha = document.querySelector('[data-nd-msg-elige]');
    const texto = mensaje || (ficha && ficha.dataset.ndMsgElige);
    if (texto) {
      let aviso = document.getElementById('nd-elige-msg');
      if (!aviso) {
        aviso = document.createElement('p');
        aviso.id = 'nd-elige-msg';
        aviso.className = 'nd-elige-msg';
        aviso.setAttribute('role', 'status');
        selector.insertAdjacentElement('afterend', aviso);
      }
      aviso.textContent = texto;
      window.setTimeout(() => aviso && aviso.remove(), 4000);
    }
    return true;
  };

  N.anadir = async (variantId, cantidad, fuente) => {
    const props = N.propiedades();
    const item = { id: Number(variantId), quantity: cantidad || 1 };
    if (Object.keys(props).length) item.properties = props;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart) {
      const r = await fetch(window.routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify({ items: [item] }) });
      const s = await r.json();
      if (s.status) return s;
      window.location.href = window.routes.cart_url;
      return s;
    }
    const body = {
      items: [item],
      sections: cart.getSectionsToRender().map((s) => s.id),
      sections_url: window.location.pathname,
    };
    const response = await fetch(window.routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify(body) });
    const state = await response.json();
    if (state.status) {
      publish(PUB_SUB_EVENTS.cartError, { source: fuente, productVariantId: variantId, errors: state.errors || state.description, message: state.message });
      return state;
    }
    publish(PUB_SUB_EVENTS.cartUpdate, { source: fuente, productVariantId: variantId, cartData: state });
    cart.renderContents(state);
    cart.classList.remove('is-empty');
    const interior = cart.querySelector('.drawer__inner');
    if (interior) interior.classList.remove('is-empty');
    return state;
  };

  N.cta = async (boton) => {
    const accion = boton.dataset.accion || 'carrito';
    const fuente = boton.dataset.fuente || 'nidito';
    const urlProducto = boton.dataset.urlProducto;
    const hayFormulario = !!N.formulario();
    if (accion === 'url' && boton.dataset.url) {
      window.location.href = boton.dataset.url;
      return;
    }
    if (accion === 'producto' || !hayFormulario) {
      if (urlProducto) window.location.href = urlProducto;
      return;
    }
    if (accion === 'formulario') {
      N.irAlFormulario();
      return;
    }
    const producto = N.leerProducto();
    const variante = N.varianteActual();
    if ((producto && producto.multiple && !N.elegido) || !variante) {
      N.irAlFormulario();
      return;
    }
    if (variante.disponible === false) {
      N.irAlFormulario(boton.dataset.textoAgotado);
      return;
    }
    const error = boton.parentElement && boton.parentElement.querySelector('[data-nd-cta-error]');
    if (error) error.hidden = true;
    boton.setAttribute('aria-busy', 'true');
    boton.setAttribute('aria-disabled', 'true');
    try {
      const estado = await N.anadir(variante.id, 1, fuente);
      if (estado && estado.status) {
        if (error) {
          error.textContent = estado.description || estado.message || '';
          error.hidden = false;
        }
        return;
      }
      N.track('nidito_add_to_cart', { variant_id: variante.id, quantity: 1, value: (variante.precio || 0) / 100, source: fuente }, boton);
      if (accion === 'checkout') {
        N.track('nidito_initiate_checkout', { variant_id: variante.id, quantity: 1, value: (variante.precio || 0) / 100, source: fuente }, boton);
        window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';
      }
    } catch (e) {
      console.error(e);
      if (error) {
        error.textContent = window.cartStrings ? window.cartStrings.error : '';
        error.hidden = false;
      }
    } finally {
      boton.removeAttribute('aria-busy');
      boton.removeAttribute('aria-disabled');
    }
  };

  N.pintarPrecios = (variante) => {
    document.querySelectorAll('[data-nd-precio]').forEach((el) => {
      if (variante) el.textContent = N.dinero(variante.precio);
    });
    document.querySelectorAll('[data-nd-anterior]').forEach((el) => {
      const hay = variante && variante.anterior > variante.precio;
      el.hidden = !hay;
      if (hay) el.textContent = N.dinero(variante.anterior);
    });
    document.querySelectorAll('[data-nd-ahorro]').forEach((el) => {
      const hay = variante && variante.anterior > variante.precio;
      el.hidden = !hay;
      if (!hay) return;
      const diff = variante.anterior - variante.precio;
      const valor = el.dataset.formato === 'importe' ? N.dinero(diff) : Math.round((diff / variante.anterior) * 100) + '%';
      el.textContent = (el.dataset.texto || '[[valor]]').replace('[[valor]]', valor);
    });
    document.querySelectorAll('[data-nd-plantilla]').forEach((el) => {
      const boton = el.closest('[data-nd-cta]');
      if (boton && (boton.dataset.accion === 'producto' || boton.dataset.accion === 'url') && !N.formulario()) return;
      if (!variante) {
        if (N.producto && boton && boton.dataset.textoAgotado) el.textContent = boton.dataset.textoAgotado;
        return;
      }
      const necesitaEleccion = N.producto && N.producto.multiple && !N.elegido;
      if (boton && boton.dataset.textoElegir && necesitaEleccion && boton.dataset.accion !== 'producto') {
        el.textContent = boton.dataset.textoElegir;
        return;
      }
      if (boton && variante && variante.disponible === false && boton.dataset.textoAgotado) {
        el.textContent = boton.dataset.textoAgotado;
        return;
      }
      const precio = variante ? N.dinero(variante.precio) : '';
      el.textContent = el.dataset.ndPlantilla.replace('[[precio]]', precio);
    });
    document.querySelectorAll('[data-nd-variante-titulo]').forEach((el) => {
      if (variante && N.producto && N.producto.multiple) el.textContent = N.elegido ? variante.titulo : el.dataset.textoSin || '';
    });
  };

  N.pintarLeyendas = () => {
    document.querySelectorAll('product-info variant-selects fieldset.product-form__input--pill').forEach((fs) => {
      const legend = fs.querySelector('legend');
      const marcado = fs.querySelector('input[type="radio"]:checked');
      if (!legend || !marcado) return;
      let valor = legend.querySelector('.nd-legend-valor');
      if (!valor) {
        valor = document.createElement('span');
        valor.className = 'nd-legend-valor';
        legend.appendChild(valor);
      }
      valor.textContent = marcado.value;
    });
  };

  N.actualizarPropiedades = (variante) => {
    document.querySelectorAll('[data-nd-prop="variante"]').forEach((input) => {
      input.value = variante && variante.proveedor ? variante.proveedor : '';
    });
  };

  N.alCambiar = (varianteDawn) => {
    N.elegido = true;
    const v = varianteDawn ? N.buscarVariante(varianteDawn.id) || {
      id: varianteDawn.id,
      titulo: varianteDawn.title,
      precio: varianteDawn.price,
      anterior: varianteDawn.compare_at_price,
      disponible: varianteDawn.available,
      opciones: varianteDawn.options,
    } : null;
    N.variante = v;
    N.pintarPrecios(v);
    N.pintarLeyendas();
    N.actualizarPropiedades(v);
    document.dispatchEvent(new CustomEvent('nidito:variante', { detail: { variante: v, dawn: varianteDawn } }));
  };

  N.revelar = () => {
    const elementos = document.querySelectorAll('.nd-reveal:not(.is-visible)');
    if (!elementos.length) return;
    if (!('IntersectionObserver' in window)) {
      elementos.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    elementos.forEach((el) => io.observe(el));
  };

  N.iniciar = () => {
    N.leerProducto();
    N.pintarPrecios(N.variante);
    N.pintarLeyendas();
    N.actualizarPropiedades(N.variante);
    N.revelar();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => N.alCambiar(data.variant));
    }
  };

  document.addEventListener('click', (evento) => {
    const boton = evento.target.closest('[data-nd-cta]');
    if (!boton) return;
    evento.preventDefault();
    if (boton.getAttribute('aria-busy') === 'true') return;
    N.cta(boton);
  });

  document.addEventListener('shopify:section:load', () => {
    N.producto = null;
    N.leerProducto();
    N.pintarPrecios(N.variante);
    N.pintarLeyendas();
    N.revelar();
  });

  if (!customElements.get('nd-galeria-color')) {
    class NdGaleriaColor extends HTMLElement {
      connectedCallback() {
        try {
          this.datos = JSON.parse(this.querySelector('script').textContent);
        } catch (e) {
          return;
        }
        this.onVariante = (e) => this.aplicar(e.detail.variante);
        document.addEventListener('nidito:variante', this.onVariante);
        const inicial = N.leerProducto() && N.variante;
        this.aplicar(inicial);
      }
      disconnectedCallback() {
        document.removeEventListener('nidito:variante', this.onVariante);
      }
      clave(variante) {
        if (!variante || this.datos.opcion < 0 || !variante.opciones) return null;
        const valor = variante.opciones[this.datos.opcion];
        return this.datos.colores[valor] || null;
      }
      aplicar(variante) {
        const clave = this.clave(variante);
        const raiz = this.closest('product-info') || document;
        const galeria = raiz.querySelector('media-gallery');
        if (!galeria) return;
        const medios = this.datos.medios || {};
        const conColor = clave && Object.values(medios).includes(clave);
        const visible = (id) => !conColor || !medios[id] || medios[id] === clave;
        const slides = galeria.querySelectorAll('[id^="Slider-Gallery"] li[data-media-id]');
        const miniaturas = galeria.querySelectorAll('[id^="Slider-Thumbnails"] li[data-target]');
        let primero = null;
        let activoOculto = false;
        slides.forEach((li) => {
          const id = li.dataset.mediaId.split('-').pop();
          const ver = visible(id);
          li.classList.toggle('nd-media-oculto', !ver);
          if (ver && !primero) primero = li;
          if (!ver && li.classList.contains('is-active')) activoOculto = true;
        });
        miniaturas.forEach((li) => {
          const id = li.dataset.target.split('-').pop();
          li.classList.toggle('nd-media-oculto', !visible(id));
        });
        if (activoOculto && primero) {
          slides.forEach((li) => li.classList.remove('is-active'));
          primero.classList.add('is-active');
          if (primero.parentElement) primero.parentElement.scrollTo({ left: primero.offsetLeft });
          const mini = galeria.querySelector(`[id^="Slider-Thumbnails"] [data-target="${primero.dataset.mediaId}"] button`);
          galeria.querySelectorAll('[id^="Slider-Thumbnails"] button[aria-current]').forEach((b) => b.removeAttribute('aria-current'));
          if (mini) mini.setAttribute('aria-current', 'true');
        }
        galeria.querySelectorAll('slider-component').forEach((s) => {
          if (typeof s.resetPages === 'function') s.resetPages();
        });
        const xr = raiz.querySelector('.product__xr-button');
        const modelos = this.datos.modelos || {};
        if (xr && Object.keys(modelos).length) {
          const modelo = (clave && modelos[clave]) || modelos._comun;
          xr.classList.toggle('nd-media-oculto', !modelo);
          if (modelo) {
            xr.setAttribute('data-shopify-model3d-id', modelo);
            if (window.ShopifyXR && typeof window.ShopifyXR.setupXRElements === 'function') window.ShopifyXR.setupXRElements();
          }
        }
      }
    }
    customElements.define('nd-galeria-color', NdGaleriaColor);
  }

  if (!customElements.get('nd-miniaturas')) {
    class NdMiniaturas extends HTMLElement {
      connectedCallback() {
        const raiz = this.closest('product-info') || document;
        this.lista = raiz.querySelector('.thumbnail-list');
        if (!this.lista) return;
        this.onClick = (e) => {
          const b = e.target.closest('.thumbnail');
          if (b) requestAnimationFrame(() => b.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }));
        };
        this.lista.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        if (this.lista) this.lista.removeEventListener('click', this.onClick);
      }
    }
    customElements.define('nd-miniaturas', NdMiniaturas);
  }

  if (!customElements.get('nd-guia-tallas')) {
    class NdGuiaTallas extends HTMLElement {
      connectedCallback() {
        const num = (x) => parseFloat(String(x).replace(',', '.'));
        try {
          this.filas = JSON.parse(this.querySelector('script[type="application/json"]').textContent).map((f) => ({ t: f.t, pecho: num(f.pecho) })).filter((f) => f.t && !isNaN(f.pecho));
        } catch (e) {
          this.filas = [];
        }
        this.pecho = this.querySelector('[data-pecho]');
        this.boton = this.querySelector('[data-elegir]');
        if (!this.pecho || !this.filas.length) return;
        this.holgura = num(this.dataset.holgura || '15');
        this.onInput = () => this.calcular();
        this.pecho.addEventListener('input', this.onInput);
        if (this.boton) this.boton.addEventListener('click', () => this.elegir());
        this.calcular();
      }
      calcular() {
        // La talla depende solo de la persona: pecho + holgura → primera talla que llega.
        const p = num(this.pecho.value);
        const out = (sel, v) => { const o = this.querySelector(sel); if (o) o.textContent = v; };
        out('[data-pecho-valor]', String(p));
        let i = this.filas.findIndex((f) => f.pecho >= p + this.holgura);
        if (i < 0) i = this.filas.length - 1;
        this.talla = this.filas[i].t;
        out('[data-talla]', this.talla);
        out('[data-texto]', (this.dataset.plantilla || '').replace(/\[\[talla\]\]/g, this.talla));
        if (this.boton) this.boton.textContent = (this.dataset.textoElegir || '[[talla]]').replace('[[talla]]', this.talla);
        this.querySelectorAll('tr[data-fila]').forEach((tr) => tr.classList.toggle('is-recomendada', tr.dataset.fila === this.talla));
        function num(x) { return parseFloat(String(x).replace(',', '.')); }
      }
      elegir() {
        const selector = document.querySelector('product-info variant-selects');
        if (!selector) {
          if (this.dataset.url) window.location.href = this.dataset.url;
          return;
        }
        const opcion = this.dataset.opcion || 'Talla';
        const radio = selector.querySelector(`input[type="radio"][name^="${CSS.escape(opcion)}-"][value="${CSS.escape(this.talla)}"]`);
        const select = selector.querySelector(`select[name="options[${CSS.escape(opcion)}]"]`);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (select && select.value !== this.talla) {
          select.value = this.talla;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (radio || select) {
          N.elegido = true;
          N.pintarPrecios(N.varianteActual());
        }
        const dialogo = this.closest('dialog');
        if (dialogo) dialogo.close();
        selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    customElements.define('nd-guia-tallas', NdGuiaTallas);
  }

  if (!customElements.get('nd-envio')) {
    class NdEnvio extends HTMLElement {
      connectedCallback() {
        const min = Number(this.dataset.min || 3);
        const max = Number(this.dataset.max || min);
        const laborables = this.dataset.laborables === 'true';
        const sumar = (n) => {
          const d = new Date();
          let k = 0;
          while (k < n) {
            d.setDate(d.getDate() + 1);
            if (!laborables || (d.getDay() !== 0 && d.getDay() !== 6)) k += 1;
          }
          return d;
        };
        const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'es', { weekday: 'short', day: 'numeric', month: 'short' });
        const destino = this.querySelector('[data-nd-envio-texto]');
        const plantilla = this.dataset.plantilla || '';
        if (!destino || !plantilla) return;
        destino.textContent = '';
        plantilla.split(/(\[\[fecha_min\]\]|\[\[fecha_max\]\])/).forEach((trozo) => {
          if (trozo === '[[fecha_min]]' || trozo === '[[fecha_max]]') {
            const b = document.createElement('strong');
            b.textContent = fmt.format(sumar(trozo === '[[fecha_min]]' ? min : max));
            destino.appendChild(b);
          } else if (trozo) {
            destino.appendChild(document.createTextNode(trozo));
          }
        });
      }
    }
    customElements.define('nd-envio', NdEnvio);
  }

  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    const grupo = d.closest('[data-nd-una-abierta]');
    if (!grupo) return;
    grupo.querySelectorAll('details[open]').forEach((o) => {
      if (o !== d) o.open = false;
    });
  }, true);

  window.Nidito = N;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', N.iniciar);
  } else {
    N.iniciar();
  }
})();
